import React, { useEffect, useState } from 'react';
import {
  Card,
  Title,
  Text,
  Table,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Badge,
} from '@tremor/react';
import Header from '../components/layout/Header';
import { patientsApi, Patient } from '../services/api';

export default function Patients() {
  const [patients, setPatients] = useState<Patient[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    patientsApi
      .list()
      .then((res) => setPatients(res.data.patients))
      .catch((err) => setError(err.response?.data?.detail || err.message || 'Failed to load patients'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="mx-auto max-w-6xl p-6">
        <Card>
          <div className="flex items-center justify-between">
            <Title>Patients</Title>
            {!loading && !error && (
              <Text>{patients.length} records</Text>
            )}
          </div>

          {loading && <Text className="mt-6">Loading…</Text>}
          {error && <Text className="mt-6 text-red-500">{error}</Text>}

          {!loading && !error && (
            <Table className="mt-6">
              <TableHead>
                <TableRow>
                  <TableHeaderCell>ID</TableHeaderCell>
                  <TableHeaderCell>Clinic</TableHeaderCell>
                  <TableHeaderCell>Status</TableHeaderCell>
                  <TableHeaderCell>Created</TableHeaderCell>
                  <TableHeaderCell className="text-right">Waiting (days)</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {patients.map((p) => (
                  <TableRow key={p.internal_id}>
                    <TableCell>{p.hm_id || p.internal_id}</TableCell>
                    <TableCell>{p.clinic || '—'}</TableCell>
                    <TableCell>
                      {p.status ? <Badge>{p.status}</Badge> : '—'}
                    </TableCell>
                    <TableCell>{p.created_date || '—'}</TableCell>
                    <TableCell className="text-right">{p.waiting_time}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Card>
      </main>
    </div>
  );
}
